export function commonFunc() {
  // エントリーバナーの表示・非表示
  $('.l-footer__entry-close').click('click', function () {
    $('.l-footer__entry').addClass('is--close');
  });
  $('.l-footer__entry .l-footer__entry-link').on('click', function () {
    if ( $(this).parent().hasClass('is--close') ) {
      $('.l-footer__entry').removeClass('is--close');
      return false;
    }
  });

  // PC 一番下までスクロールすると、追従ボタンを非表示にする
  let pageHeight = $('html body').height();
  let windowHeight = $(window).height();
  let scrollMax = pageHeight - windowHeight - 50;
  $(window).scroll(function () {
    let scrollTop = $(this).scrollTop();
    if ( scrollTop >= scrollMax ) {
      $('.p-fixed-button').addClass('is--hide');
    } else {
      $('.p-fixed-button').removeClass('is--hide');
    }
  });

  // Gnav子メニュー
  if (window.matchMedia( "(min-width: 1024px)" ).matches) {
    $('.l-header__nav-list > li').hover(
      function () {
        $(this).find('.sub-menu').stop().fadeIn(200);
      },
      function () {
        $(this).find('.sub-menu').stop().fadeOut(200);
      }
    );
  }

  $('.p-members-section').each(function () {
    if ( $(this).find('.p-members-section__img img').length == 0 ) {
      $(this).find('.p-members-section__img').css('width', '0');
      $(this).find('.p-members-section__text').css('width', '100%');
    }
  });
}
